module.exports = __webpack_public_path__ + "media/images/logos/meta-0b2735967ed9345eed815a1ed3672ed1.png";